import App from '@sophocles/components/App/App';

export default App;
